import type { ControleTempo } from '../types';

export const CONTROLES_TEMPO: ControleTempo[] = [
  { id: 'sem-relogio', nome: 'Sem relógio', minutos: 0, incremento: 0 },
  { id: '1-0', nome: 'Ultrarrápida · 1 + 0', minutos: 1, incremento: 0 },
  { id: '2-1', nome: 'Ultrarrápida · 2 + 1', minutos: 2, incremento: 1 },
  { id: '3-0', nome: 'Relâmpago · 3 + 0', minutos: 3, incremento: 0 },
  { id: '3-2', nome: 'Relâmpago · 3 + 2', minutos: 3, incremento: 2 },
  { id: '5-0', nome: 'Relâmpago · 5 + 0', minutos: 5, incremento: 0 },
  { id: '10-0', nome: 'Rápida · 10 + 0', minutos: 10, incremento: 0 },
  { id: '10-5', nome: 'Rápida · 10 + 5', minutos: 10, incremento: 5 },
  { id: '15-10', nome: 'Rápida · 15 + 10', minutos: 15, incremento: 10 },
  { id: '30-0', nome: 'Clássica · 30 + 0', minutos: 30, incremento: 0 },
  { id: 'personalizado', nome: 'Personalizado', minutos: 10, incremento: 0 }
];
